import React from 'react'
import { Box, ButtonGroup, useStyleConfig } from '@chakra-ui/react'
function ButtonSwitch(props) {
  const { variant, children, spacing = '2', ...rest } = props
  const styles = useStyleConfig('ButtonSwitch', { variant })
  return (
    <Box __css={styles} {...rest}>
      <ButtonGroup spacing={spacing}>{children}</ButtonGroup>
    </Box>
  )
}

export default ButtonSwitch
